/* eslint-disable camelcase */
import React from "react";

import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

import { useTransparentHeader } from "@companion-core/shared/app/Hooks/transparentHeader";
import { Banner } from "@companion-core/shared/app/Components/Banner";
import { SubCrossSellProps } from "./subCrossSell.model";
import { RequestProposalCard } from "@companion-core/shared/app/Components/Requests/RequestProposalCard";
import { serviceIcons } from "@companion-core/shared/app/Constants/myRequests";
import { getCloudinaryOptimizedUrl } from "@companion-core/shared/app/Utils/cloudinary";
import { useBellLink } from "@companion-core/shared/app/Hooks/useBellLink";
import { trackClickCrossSellGroupeCCS } from "@companion-core/shared/app/tracking/crossSell";

export const SubCrossSell = ({ data, requestId }: SubCrossSellProps) => {
  const { t } = useTranslation();
  useTransparentHeader();
  const navigate = useNavigate();
  const { openBellLink } = useBellLink({ platform: "web", bellReferrer: "cross-sell" });

  if (!data) return null;
  const { sub_cross_sells } = data.cross_sell_concierge;

  return (
    <div className="sub-cross-sell">
      <Banner
        imageUrl={data.medias?.length > 0 ? data.medias[0].url : ""}
        shadowType="gradient"
        boxShadow
      />
      <section className="sub-cross-sell__content">
        <div className="sub-cross-sell__text">
          <h3 className="title-3">{data.title}</h3>
          <p className="body-text-6">{t("cross-sell.sub-cross-sell.description")}</p>
        </div>
        <div className="sub-cross-sell__list">
          {sub_cross_sells
            ?.sort((a, b) => a.cross_sell_concierge.order - b.cross_sell_concierge.order)
            .map((element) => (
              <RequestProposalCard
                key={element.id}
                testID={`cross-sell__list-element-${element.id}`}
                media={
                  element.medias?.length > 0
                    ? getCloudinaryOptimizedUrl(element.medias[0].url, { contentType: "logo" })
                    : undefined
                }
                mediaAlt={element.medias?.[0]?.description_alt}
                iconOverlay={serviceIcons[element.family] ?? "JP-Concierge-bell"}
                title={element.title}
                subtitle={element.description}
                onClick={
                  element?.cross_sell_concierge?.sub_cross_sells?.length > 0
                    ? () => navigate(`/my-requests/cross-sell/${requestId}/${element.id}`)
                    : () => {
                        trackClickCrossSellGroupeCCS({
                          family: element.family,
                          subFamily: element.subfamily,
                          requestId,
                          contentId: element.id,
                        });
                        openBellLink(element.bell_deep_link);
                      }
                }
              />
            ))}
        </div>
      </section>
    </div>
  );
};
